import React, { useState, useEffect } from "react";
import {
  // Page,
  // Text,
  // View,
  // Document,
  // StyleSheet,
  // Image,
  Font,
} from "@react-pdf/renderer";
import { utilGetCollectionFilter } from "../../../util/UtilsFirebase";
// import ReactDOM from "react-dom";
// import { PDFViewer } from "@react-pdf/renderer";
import { Button, Modal, Col, Row, Card, ListGroup } from "react-bootstrap";
import "./Ticket.css";
import impresoraManager from "../../ImpresoraManager";

const Ticket = ({
  orden,
  registro,
  show,
  handleClose,
  impresion,
  setImpresion,
  cocina,
}) => {
  const [localOrden] = useState(orden);
  const [total, setTotal] = useState(0);
  const [itemsPerPage] = useState(1);
  const [empleado, setEmpleado] = useState("");
  const currentItems = orden?.detalle;
  const totalPages = orden?.detalle
    ? Math.ceil(localOrden?.detalle.length / itemsPerPage)
    : 0;

  Font.register({
    family: "Oswald",
    src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
  });

  // const styles = StyleSheet.create({
  //   body: {
  //     paddingTop: 20,
  //     paddingBottom: 20,
  //     paddingHorizontal: 20,
  //   },
  //   title: {
  //     fontSize: 6.5,
  //     textAlign: "center",
  //     fontFamily: "Oswald",
  //   },
  //   author: {
  //     fontSize: 3,
  //     textAlign: "center",
  //     marginBottom: 40,
  //   },
  //   subtitle: {
  //     fontSize: 6.5,
  //     textAlign: "center",
  //     fontFamily: "Oswald",
  //   },
  //   text: {
  //     fontSize: 5.5,
  //     textAlign: "center",
  //     fontFamily: "Oswald",
  //   },
  //   image: {
  //     width: 37,
  //     height: 17,
  //   },
  //   row: {
  //     flexDirection: "row",
  //   },
  //   titleprod: {
  //     flex: 3,
  //     fontSize: 5.5,
  //     textAlign: "center",
  //     margin: 0,
  //     padding: 0,
  //     flexGrow: 3,
  //   },
  //   titletrow: {
  //     flex: 3,
  //     margin: 0,
  //     fontSize: 5.5,
  //     padding: 3,
  //     flexGrow: 3,
  //   },
  //   contentrow: {
  //     flex: 1,
  //     fontSize: 5.5,
  //     textAlign: "center",
  //     margin: 0,
  //     padding: 3,
  //     flexGrow: 1,
  //   },
  //   header: {
  //     fontSize: 4,
  //     marginBottom: 20,
  //     textAlign: "center",
  //     color: "grey",
  //   },
  // });

  // const App = () => (
  //   <PDFViewer className="PDFViewer">
  //     <MyDocument />
  //   </PDFViewer>
  // );

  // const MyDocument = () => (
  //   <Document>
  //     {orden.fecha ? (
  //       <Page size={[227, 610]} style={styles.body}>
  //         <View style={styles.row}>
  //           <Image
  //             alt=""
  //             src={registro.imgticket ? registro.imgticket : registro.img}
  //             style={{ width: 37, height: 25 }}
  //           ></Image>
  //           <View style={styles.contentrow}>
  //             <Text style={styles.title}>{registro.nameticket}</Text>
  //             <Text style={styles.title}>
  //               {registro.razon_socialticket
  //                 ? "Razon social: " + registro.razon_social
  //                 : ""}
  //             </Text>
  //             <Text style={styles.title}>
  //               {registro.calleticket
  //                 ? registro.calleticket +
  //                   " #" +
  //                   registro.numdomticket +
  //                   " Col." +
  //                   registro.coloniaticket +
  //                   " C.P. " +
  //                   registro.codigopticket
  //                 : ""}
  //             </Text>
  //             <Text style={styles.title}>
  //               {registro.municipioticket
  //                 ? registro.municipioticket +
  //                   ", " +
  //                   registro.estadoticket +
  //                   " " +
  //                   registro.paisticket
  //                 : ""}
  //             </Text>
  //             <Text style={styles.subtitle}>
  //               {registro.sucursalticket
  //                 ? "Sucursal:" + registro.sucursalticket
  //                 : ""}
  //             </Text>
  //             <Text style={styles.subtitle}>
  //               {registro.rfcticket ? "RFC:" + registro.rfcticket : ""}
  //             </Text>
  //             <Text style={styles.subtitle}>
  //               {registro.phoneticket
  //                 ? "Telefono: " + registro.phoneticket
  //                 : ""}
  //             </Text>
  //           </View>
  //           <Image
  //             src="/static/media/logonaranja.47703c147962eb0583b9.png"
  //             style={[styles.image]}
  //           ></Image>
  //         </View>
  //         <View style={styles.row}>
  //           <Text
  //             style={[
  //               styles.contentrow,
  //               { textAlign: "left", paddingTop: 10, paddingLeft: 0 },
  //             ]}
  //           >
  //             Folio: {orden.folio}
  //           </Text>
  //           <Text
  //             style={[
  //               styles.contentrow,
  //               { textAlign: "right", paddingTop: 10 },
  //             ]}
  //           >
  //             Fecha y hora:{" "}
  //             {orden.fecha.seconds
  //               ? new Date(orden.fecha.seconds * 1000).toLocaleDateString() +
  //                 " " +
  //                 new Date(orden.fecha.seconds * 1000).toLocaleTimeString()
  //               : orden.fecha.toLocaleDateString() +
  //                 " " +
  //                 orden.fecha.toLocaleTimeString()}
  //           </Text>
  //         </View>
  //         {orden.table ? (
  //           <Text style={{ paddingTop: 2, paddingBottom: 5, fontSize: 5.5 }}>
  //             Mesa: {orden.table}
  //           </Text>
  //         ) : (
  //           ""
  //         )}
  //         <Text style={{ paddingBottom: 5, fontSize: 5.5 }}>
  //           Cliente: {orden.user_name}
  //         </Text>
  //         <Text style={{ paddingBottom: 10, fontSize: 5.5 }}>
  //           Atendido por: {empleado}
  //         </Text>
  //         <View style={styles.row}>
  //           <Text style={styles.titleprod}>Producto:</Text>
  //           <Text style={styles.contentrow}>Cantidad:</Text>
  //           <Text style={styles.contentrow}>Precio unitario:</Text>
  //           <Text style={styles.contentrow}>Total:</Text>
  //         </View>
  //         <View style={styles.row}></View>
  //         {currentItems.map((item, index) => (
  //           <View style={styles.row}>
  //             <Text style={styles.titletrow} fixed>
  //               {item.name} ({item.ncosto}){"\n"}
  //               {item.ingredientes && Object.keys(item.ingredientes).length > 0
  //                 ? "-Ingredientes\n"
  //                 : ""}
  //               {item.ingredientes ? (
  //                 Object.keys(item.ingredientes).map((obj, i) => {
  //                   return (
  //                     <Text style={styles.titleprod}>
  //                       -{item.ingredientes[obj].name}
  //                       {": " + item.ingredientes[obj].cantidad}
  //                       {"\n"}
  //                     </Text>
  //                   );
  //                 })
  //               ) : (
  //                 <></>
  //               )}
  //               {item.anadidos && Object.keys(item.anadidos).length > 0
  //                 ? "-Añadidos\n"
  //                 : ""}
  //               {item.anadidos ? (
  //                 Object.keys(item.anadidos).map((obj, i) => {
  //                   return (
  //                     <Text style={styles.titleprod}>
  //                       -{item.anadidos[obj].name}(
  //                       {parseFloat(
  //                         item.anadidos[obj].precio *
  //                           item.anadidos[obj].cantidad,
  //                       ) > 0
  //                         ? "+$" +
  //                           (
  //                             item.anadidos[obj].precio *
  //                             item.anadidos[obj].cantidad
  //                           ).toFixed(2)
  //                         : parseFloat(item.anadidos[obj].costo) > 0
  //                           ? "$" +
  //                             (
  //                               parseFloat(item.anadidos[obj].costo) *
  //                               item.anadidos[obj].cantidad
  //                             ).toFixed(2)
  //                           : "Gratis"}
  //                       ){"\n"}
  //                     </Text>
  //                   );
  //                 })
  //               ) : (
  //                 <></>
  //               )}
  //             </Text>
  //             <Text style={styles.contentrow}>{item.cantidad}</Text>
  //             <Text style={styles.contentrow}>
  //               ${parseFloat(item.costo).toFixed(2)}{" "}
  //             </Text>
  //             <Text style={styles.contentrow}>${item.total.toFixed(2)} </Text>
  //           </View>
  //         ))}
  //         <View style={styles.row}>
  //           <Text style={styles.contentrow}>
  //             ---------------------------------------------------------------------------------------------------------------
  //           </Text>
  //         </View>
  //         <View style={styles.row}>
  //           <Text style={styles.titletrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}>Subtotal:</Text>
  //           <Text style={styles.contentrow}>
  //             ${(orden.total / (1 + orden.iva / 100)).toFixed(2)}{" "}
  //           </Text>
  //         </View>
  //         <View style={styles.row}>
  //           <Text style={styles.titletrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}>IVA ({orden.iva}%):</Text>
  //           <Text style={styles.contentrow}>${orden.cobroiva.toFixed(2)} </Text>
  //         </View>
  //         <View style={styles.row}>
  //           <Text style={styles.titletrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}>IEPS:</Text>
  //           <Text style={styles.contentrow}>$0.00 </Text>
  //         </View>
  //         <Text style={[{ textAlign: "right", paddingTop: 5, fontSize: 5.5 }]}>
  //           Total: ${orden.total.toFixed(2)}{" "}
  //           {window.convertir.NumerosALetras(orden.total.toFixed(2))}
  //         </Text>
  //         <View style={[styles.row, { paddingTop: 7 }]}>
  //           <Text style={{ flex: 1, flexGrow: 1, fontSize: 5.5 }}>Total:</Text>
  //           <Text style={styles.contentrow}>${orden.total.toFixed(2)}</Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //         </View>
  //         <View style={[styles.row, { paddingTop: 2 }]}>
  //           <Text style={{ flex: 1, flexGrow: 1, fontSize: 5.5 }}>
  //             Puntos utilizados:
  //           </Text>
  //           <Text style={styles.contentrow}>{orden.puntosusados}</Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //         </View>
  //         <Text style={{ textAlign: "left", fontSize: 5.5 }}>
  //           ------------------------------------------------------
  //         </Text>
  //         <View style={[styles.row, { paddingTop: 2 }]}>
  //           <Text style={{ flex: 1, flexGrow: 1, fontSize: 5.5 }}>
  //             Nuevo total:
  //           </Text>
  //           <Text style={styles.contentrow}>
  //             $
  //             {(
  //               orden.total -
  //               orden.puntosusados *
  //                 (localOrden.equivalenciapuntos
  //                   ? parseFloat(localOrden.equivalenciapuntos)
  //                   : 0)
  //             ).toFixed(2)}
  //           </Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //         </View>
  //         <View style={[styles.row, { paddingTop: 2 }]}>
  //           <Text style={{ flex: 1, flexGrow: 1, fontSize: 5.5 }}>Pago:</Text>
  //           <Text style={styles.contentrow}>
  //             ${parseFloat(orden.cobro).toFixed(2)}
  //           </Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //         </View>
  //         <View style={[styles.row, { paddingTop: 2, fontSize: 5.5 }]}>
  //           <Text style={{ flex: 1, flexGrow: 1, fontSize: 5.5 }}>Cambio:</Text>
  //           <Text style={styles.contentrow}>
  //             ${parseFloat(orden.cambio).toFixed(2)}
  //           </Text>
  //           <Text style={styles.contentrow}></Text>
  //           <Text style={styles.contentrow}></Text>
  //         </View>
  //         <Text
  //           style={{
  //             textAlign: "left",
  //             paddingTop: 15,
  //             paddingBottom: 5,
  //             fontSize: 5.5,
  //           }}
  //         >
  //           Metodo de pago: {orden.tipo_pago}
  //         </Text>
  //         <Text style={{ textAlign: "left", paddingBottom: 15, fontSize: 5.5 }}>
  //           Pago en una sola exhibición.
  //         </Text>
  //         {registro.Tpuntos ? (
  //           <Text
  //             style={{ textAlign: "left", paddingBottom: 10, fontSize: 5.5 }}
  //           >
  //             Puntos generados: {orden.puntosgenerados}
  //           </Text>
  //         ) : (
  //           <></>
  //         )}
  //         <Text style={styles.title}>FACTURACION</Text>
  //         <Text style={styles.text}>
  //           Estimado cliente si usted desea facturar su compra puede hacerlo
  //           mediante
  //         </Text>
  //         <Text style={styles.text}>
  //           el siguiente codigo QR, ahi podra realizar la factura por su
  //           consumo.
  //         </Text>
  //         <Image
  //           src={"https://quickchart.io/qr?text=QRT-" + orden.id}
  //           style={{ width: 120, height: 120, marginHorizontal: 35 }}
  //         ></Image>
  //         <Text style={[styles.title, { marginBottom: 10 }]}>
  //           Codigo de su orden :{" " + orden.id}
  //         </Text>
  //         <Text style={styles.title}>¡Gracias por su compra!</Text>
  //         <Text style={styles.text}>
  //           Queremos su opinion, califica nuestro servicio por medio del QR.
  //         </Text>
  //       </Page>
  //     ) : (
  //       <></>
  //     )}
  //   </Document>
  // );

  // const Imprimir = () => {
  //   var myWindow = window.open("", "PRINT");
  //   myWindow.document.write(
  //     '<html><head><title>Ticket de venta</title><link rel="icon" href="/favicon.ico"><style type="text/css">html, body, div, iframe { margin:0; padding:0; height:100%; }iframe { display:block; width:100%; border:none; }</style></head><body></body></html>',
  //   );
  //   ReactDOM.render(<App />, myWindow.document.body);
  //   setTimeout(function () {
  //     myWindow.document.body
  //       .getElementsByTagName("iframe")[0]
  //       .contentWindow.print();
  //   }, 1000);
  // };

  // const ImprimirN = () => {
  //   var pri = document.getElementById("ifmcontentTicket").contentWindow;
  //   pri.document.open();
  //   pri.document.write(
  //     '<html><head><title>Ticket de venta</title><link rel="icon" href="/favicon.ico"><style type="text/css">html, body, div, iframe { margin:0; padding:0; height:100%; }iframe { display:block; width:100%; border:none; }</style></head><body></body></html>',
  //   );
  //   ReactDOM.render(<App />, pri.document.body);
  //   pri.document.close();
  //   setTimeout(function () {
  //     pri.document.getElementsByClassName("PDFViewer")[0].contentWindow.print();
  //   }, 1000);
  // };

  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    if (orden?.fecha) {
      setTotal(localOrden?.total);
      if (localOrden?.atendio !== "Administrador") {
        const personal = utilGetCollectionFilter(
          "users",
          "id",
          "==",
          localOrden?.atendio,
        );
        personal.then((result) => {
          if (result.length > 0) {
            setEmpleado(result[0].fullName);
          }
        });
      } else {
        setEmpleado(localOrden?.atendio);
      }
    }
  }, [orden, localOrden]);

  useEffect(() => {
    if (impresion) {
      setImpresion(false);
      if (localOrden?.atendio && localOrden?.atendio !== "Administrador") {
        const personal = utilGetCollectionFilter(
          "users",
          "id",
          "==",
          localOrden?.atendio,
        );
        personal.then((result) => {
          if (result.length > 0) {
            setEmpleado(result[0].fullName);
            impresoraManager
              .imprimir(orden, registro, result[0].fullName, cocina)
              .catch((error) => {
                alert(error);
              });
            // ImprimirN();
          }
        });
      } else {
        setEmpleado("Administrador");
        impresoraManager
          .imprimir(orden, registro, "Administrador", cocina)
          .catch((error) => {
            alert(error);
          });
        // ImprimirN();
      }
      setTotal(localOrden?.total);
      console.log(orden);
      handleClose();
    }
  }, [
    cocina,
    handleClose,
    impresion,
    localOrden?.atendio,
    localOrden?.total,
    orden,
    registro,
    setImpresion,
  ]);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header>Ticket de venta</Modal.Header>
      <Modal.Body id="PDF">
        <Col xs={12} md={12} lg={12} xl={12}>
          {localOrden !== null ? (
            <Card style={{}}>
              <Card.Header>
                <Row>
                  <Col md={3} className="centerimg">
                    <label className="marginlbl">
                      <img
                        id="logo_img"
                        src={
                          registro.imgticket ? registro.imgticket : registro.img
                        }
                        height="92"
                        width="132"
                        alt=""
                      />
                    </label>
                  </Col>
                  <Col md={6}>
                    {registro.nameticket ? (
                      <Col xs={12} className="centerimg">
                        <label className="marginlbl">
                          <strong>{registro.nameticket}</strong>
                        </label>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {registro.razon_socialticket ? (
                      <Col xs={12} className="centerimg">
                        <label className="marginlbl">
                          <strong>
                            {"Razon social: " + registro.razon_socialticket}
                          </strong>
                        </label>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {registro.calleticket &&
                    registro.numdomticket &&
                    registro.coloniaticket &&
                    registro.codigopticket ? (
                      <Col xs={12} className="centerimg">
                        <label className="marginlbl">
                          <strong>
                            {registro.calleticket +
                              " #" +
                              registro.numdomticket +
                              " Col. " +
                              registro.coloniaticket +
                              " C.P. " +
                              registro.codigopticket}
                          </strong>
                        </label>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {registro.municipioticket &&
                    registro.estadoticket &&
                    registro.paisticket ? (
                      <Col xs={12} className="centerimg">
                        <label className="marginlbl">
                          <strong>
                            {registro.municipioticket +
                              ", " +
                              registro.estadoticket +
                              " " +
                              registro.paisticket}
                          </strong>
                        </label>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {registro.rfcticket ? (
                      <Col xs={12} className="centerimg">
                        <label className="marginlbl">
                          <strong>{"RFC: " + registro.rfcticket}</strong>
                        </label>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {registro.telefono ? (
                      <Col xs={12} className="centerimg">
                        <label className="marginlbl">
                          {"Telefono: " + registro.phoneticket}
                        </label>
                      </Col>
                    ) : (
                      <></>
                    )}
                  </Col>
                  <Col xs={3} className="centerimg">
                    <label className="marginlbl">
                      <img
                        id="logo_img"
                        src="/static/media/logonaranja.47703c147962eb0583b9.png"
                        height="80"
                        width="139"
                        alt=""
                      />
                    </label>
                  </Col>
                </Row>
              </Card.Header>
              <Row style={{ marginTop: 5, marginBottom: 2 }}>
                <Col md={6}>
                  <span className="mrgBtn">
                    <strong>Folio: </strong> {orden?.folio}
                  </span>
                </Col>
                {orden?.fecha ? (
                  <Col md={6}>
                    <span className="mrgBtn">
                      <strong>Fecha y hora: </strong>{" "}
                      {new Date(
                        orden?.fecha.seconds * 1000,
                      ).toLocaleDateString() +
                        " " +
                        new Date(
                          orden?.fecha.seconds * 1000,
                        ).toLocaleTimeString()}
                    </span>
                  </Col>
                ) : (
                  <></>
                )}
              </Row>
              <Row style={{ marginTop: 2, marginBottom: 2 }}>
                <Col md={orden?.table ? 6 : 12}>
                  <span className="mrgBtn">
                    <strong>Cliente: </strong> {orden?.user_name}
                  </span>
                </Col>
                {orden?.table ? (
                  <Col xs={6}>
                    <span className="mrgBtn">
                      <strong>Mesa:</strong> {orden?.table}
                    </span>
                  </Col>
                ) : (
                  <></>
                )}
              </Row>
              <Row style={{ marginTop: 2, marginBottom: 8 }}>
                <Col md={6}>
                  <span className="mrgBtn">
                    <strong>Atendido por: </strong> {empleado}
                  </span>
                </Col>
                <Col md={6}>
                  <span className="mrgBtn">
                    <strong>Puntos generados: </strong> {orden?.puntosgenerados}
                  </span>
                </Col>
              </Row>
              <ListGroup>
                <Row>
                  <Col xs={6}>
                    <div className="d-flex justify-content-between">
                      <span className="mrgBtn">
                        <strong>Producto: </strong>
                      </span>
                    </div>
                  </Col>
                  <Col xs={2}>
                    <div className="d-flex justify-content-between">
                      <span className="mrgBtn">
                        <strong>Cantidad:</strong>
                      </span>
                    </div>
                  </Col>
                  <Col xs={2}>
                    <div className="d-flex justify-content-between">
                      <span className="mrgBtn">
                        <strong>Precio:</strong>
                      </span>
                    </div>
                  </Col>
                  <Col xs={2}>
                    <div className="d-flex justify-content-between">
                      <span className="mrgBtn">
                        <strong>Total:</strong>
                      </span>
                    </div>
                  </Col>
                </Row>
                {currentItems?.map((item, index) => (
                  <ListGroup.Item key={item.idv4}>
                    <Row>
                      <Col xs={6}>
                        <div className=" justify-content-between">
                          <Row>
                            <span className="">
                              {item.name}({item.ncosto})
                            </span>
                          </Row>
                          {item.ingredientes &&
                          Object.keys(item.ingredientes).length > 0 ? (
                            <strong>-Ingredientes</strong>
                          ) : (
                            <></>
                          )}
                          {item.ingredientes ? (
                            Object.keys(item.ingredientes).map((obj, i) => {
                              return (
                                <Row style={{ paddingLeft: "10px" }}>
                                  <div className="margindiv">
                                    <strong>
                                      {item.ingredientes[obj].name}
                                    </strong>
                                    :{" " + item.ingredientes[obj].cantidad}
                                  </div>
                                </Row>
                              );
                            })
                          ) : (
                            <></>
                          )}
                          {item.ingredientes &&
                          Object.keys(item.anadidos).length > 0 ? (
                            <strong>-Añadidos</strong>
                          ) : (
                            <></>
                          )}
                          {item.anadidos ? (
                            Object.keys(item.anadidos).map((obj, i) => {
                              return (
                                <Row style={{ paddingLeft: "10px" }}>
                                  <div className="margindiv">
                                    <strong>{item.anadidos[obj].name}</strong>(
                                    {parseFloat(
                                      item.anadidos[obj].precio *
                                        item.anadidos[obj].cantidad,
                                    ) > 0
                                      ? "+$" +
                                        (
                                          item.anadidos[obj].precio *
                                          item.anadidos[obj].cantidad
                                        ).toFixed(2)
                                      : parseFloat(item.anadidos[obj].costo) > 0
                                        ? "$" +
                                          (
                                            parseFloat(
                                              item.anadidos[obj].costo,
                                            ) * item.anadidos[obj].cantidad
                                          ).toFixed(2)
                                        : "Gratis"}
                                    )
                                  </div>
                                </Row>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </div>
                      </Col>
                      <Col xs={2}>
                        <div className="d-flex justify-content-between">
                          <span className="mrgBtn">{item.cantidad}</span>
                        </div>
                      </Col>
                      <Col xs={2}>
                        <div className="d-flex justify-content-between">
                          <span className="mrgBtn">${item.costo}</span>
                        </div>
                      </Col>
                      <Col xs={2}>
                        <div className="d-flex justify-content-between">
                          <span className="mrgBtn">${item.total}</span>
                        </div>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
              <Card.Footer>
                <Row>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                  <Col md={2}></Col>
                  <Col md={4}>
                    <Row>
                      <Col md={6}>
                        <span className="margen-tam">SUBTOTAL:</span>
                      </Col>
                      <Col md={6}>
                        <span className="margen-tam">
                          ${(total / (1 + orden?.iva / 100)).toFixed(2)}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <span className="margen-tam">IVA({orden?.iva}%):</span>
                      </Col>
                      <Col md={6}>
                        <span className="margen-tam">
                          ${parseFloat(orden?.cobroiva).toFixed(2)}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <span className="margen-tam">PUNTOS:</span>
                      </Col>
                      <Col md={6}>
                        <span className="margen-tam">
                          {parseFloat(orden?.puntosusados)}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <span className="margen-tam">TOTAL:</span>
                      </Col>
                      <Col md={6}>
                        <span className="margen-tam">
                          $
                          {(
                            total -
                            parseFloat(orden?.puntosusados) *
                              (localOrden?.equivalenciapuntos
                                ? parseFloat(localOrden?.equivalenciapuntos)
                                : 0)
                          ).toFixed(2)}
                        </span>
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <Col md={6}>
                        <span className="margen-tam">PAGO:</span>
                      </Col>
                      <Col md={6}>
                        <span className="margen-tam">
                          ${parseFloat(orden?.cobro).toFixed(2)}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <span className="margen-tam">CAMBIO:</span>
                      </Col>
                      <Col md={6}>
                        <span className="margen-tam">
                          ${parseFloat(orden?.cambio).toFixed(2)}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <br />
                <Row>
                  <span className="margen-tam">GRACIAS POR SU COMPRA</span>
                </Row>{" "}
              </Card.Footer>
            </Card>
          ) : (
            <></>
          )}
        </Col>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() =>
            impresoraManager
              .imprimir(orden, registro, empleado, false)
              .catch((error) => {
                alert(error);
              })
          }
          // onClick={() => Imprimir()}
        >
          Imprimir ticket
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          CANCELAR
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Ticket;
